 
import { routes } from "../../../../routers/routes";
import Breadcrumbs from "../../../commonComponents/breadcrumbs";
import JPJPage from "./JPJPage";

const AboutUs1Container = () => {
  return (
    <>
      <Breadcrumbs title="JPJ Services" url={routes.Home.CarDemo1} mainClass="page-breadcrumbs-section page-breadcrumbs-section-aboutus" />
      <JPJPage />
    </>
  );
};

export default AboutUs1Container;
